import { createGlobalStyle } from 'styled-components';

export const GlobalSearchStyles = createGlobalStyle`
.ais-InstantSearch__root {
  display: flex;
  flex-direction: column;
  height: 496px;
}
`;
